module.exports = __webpack_public_path__ + "static/img/1.2a93c59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/eng/1.png
// module id = VM5O
// module chunks = 0